<script>
  import { Selector } from '@steeze-ui/heroicons'
  import { Icon } from '@steeze-ui/svelte-icon'
</script>

<Icon src={Selector} class="w-[18px] h-[18px]" />
